import { render, staticRenderFns } from "./LogsDialog.vue?vue&type=template&id=43586828&"
import script from "./LogsDialog.vue?vue&type=script&lang=ts&"
export * from "./LogsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports